import React from "react";
import FooterInfo from "./footerInfo";
const FooterSide = () => {

  const handleEscrowClick = () => {
    window.open(
      "https://cp.mcash.co.kr/mcht/usersite/main/escrowAuth.do?bizNo=1018162201",
      "_blank",
    );
  };

  return (
    
    <div className="footer-outer">
      <div className="footer-side-wrap">
        <footer className="footer-side-inner">
          <div className="footer-info-wrap">
              <div className="footer-link">
                <a
                  href="https://about.dongascience.com/company/dongascience"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  회사소개
                </a>
                <span className="footer-divider">|</span>
                <a 
                  href="https://help.dongascience.com/helpinfo/knowledge"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  저작권 · 콘텐츠 이용안내
                </a>
                <span className="footer-divider">|</span>
                <a
                  href="https://help.dongascience.com/helpinfo/privacy"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <strong style={{fontWeight: 'bold'}}>개인정보 처리방침</strong>
                </a>
                <span className="footer-divider">|</span>
                <a
                  href="https://about.dongascience.com/advertise/magazine"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  광고안내
                </a>
                <span className="footer-divider">|</span>
                <a
                  href="https://help.dongascience.com/contents/list/101000 "
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  고객센터
                </a>
              </div>

            {/* <div className="footer-side-award-wrap" >
              <img src="/image_footer_side_pc.png" alt="footer-image_pc" />
            </div> */}
            <div className="footer-side-award-wrap" >
              <img src="/image_footer_side_m.png" alt="footer-image_pc" />
            </div>
            <p className="footer-copy">
              Copyright © Donga Science. All rights reserved.
            </p>
          </div>
        </footer>

        
      </div>
    </div>
  )
}
export default FooterSide;